import React from "react";
import { useParams } from "react-router-dom";

export default function Brand() {
  const { brandName } = useParams();
  return <div>{brandName ? `Brand: ${brandName}` : "Brand"}</div>;
}
